module.exports = __webpack_public_path__ + "static/media/stepper-plan-icon-active.554ef93c.svg";